import { AccountFacade } from '@mode/accounts/contract';
import { DatasetFacade } from '@mode/dataset/contract';
import { SelectionOptionDirective, SelectOption } from '../../select-field/select-field.component';

class TableListRowDropdownController {
  static $inject = ['AccountFacade', 'DatasetFacade'];

  constructor(
    private accountFacade: AccountFacade,
    private datasetFacade: DatasetFacade
  ) {}

  private options!: SelectOption[];
  private onSelect!: ($args: { $option: SelectOption; $options?: Object }) => void;
  private dropOpen = false;

  handleSelect($option: SelectOption) {
    this.onSelect({ $option });
  }

  deleteDataset(token: string): void {
    this.datasetFacade.openDeleteDatasetModalFromCollectionList(token);
  }

  handleConfirm($option: SelectOption, $options: Object = {}) {
    this.onSelect({ $option, $options });
  }
}

export const TableListRowDropdownComponent: angular.IComponentOptions = {
  controller: TableListRowDropdownController,
  controllerAs: 'ctrl',
  bindings: {
    dropdownTooltipMessage: '<',
    dropdownTooltipEnabled: '<',
    options: '<',
    onSelect: '&',
  },
  template: `
    <div uib-dropdown
         ng-if="ctrl.options.length"
         is-open="ctr.dropOpen"
         class="dropdown table-list-row-dropdown"
         uib-tooltip="{{ ctrl.dropdownTooltipMessage }}"
         tooltip-enable="ctrl.dropdownTooltipEnabled"
         tooltip-append-to-body="true"
         tooltip-placement="bottom"
         tooltip-class="wrapping-tooltip-lg"
         tooltip-popup-delay="500"
         >
      <a uib-dropdown-toggle class="dropdown-toggle overflow-toggle" ng-disabled="ctrl.dropdownTooltipEnabled">
        <capra-icon class="kebab-menu" icon="icon-kebab"></capra-icon>
      </a>
      <ul uib-dropdown-menu class="dropdown-menu dropdown-menu-right pull-right overflow-menu">
        <li ng-repeat="option in ctrl.options"
            class="overflow-menu-item"
            ng-click="ctr.dropOpen = false"
            ng-class="{'divider': option.isDivider}">
          <button ng-if="option.directive && option.directive.name === '${SelectionOptionDirective.SpaceReportPin}'"
             space-report-pin-link
             class="button-link"
             report="option.directive.attrs.report"
             space-report-pin="option.directive.attrs.report.savedSpaceReportPin"
             space="option.directive.attrs.space">
            {{ option.label }}
          </button>
          <button
             ng-if="option.directive && option.directive.name === '${SelectionOptionDirective.MoveSpace}'"
             move-space
             class="button-link"
             report="option.directive.attrs.report"
             account="ctrl.accountFacade.user$ | async:this"
             owner="option.directive.attrs.owner"
             on-move="ctrl.handleConfirm(option, { targetIsExistingSpace: true })"
             moved-to-space="ctrl.handleConfirm(option, { space: $space, targetIsNewSpace: true })">
            {{ option.label }}
          </button>
          <button ng-if="option.directive && option.directive.name === '${SelectionOptionDirective.ShortcutSpace}'"
             shortcut-space
             class="button-link"
             account="ctrl.accountFacade.user$ | async:this"
             owner="option.directive.attrs.owner"
             moved-to-space="ctrl.handleConfirm(option, { space: $space, targetIsNewSpace: true })"
             report="option.directive.attrs.report"
             space="option.directive.attrs.space">
            {{ option.label }}
          </button>
          <button ng-if="option.directive && option.directive.name === '${SelectionOptionDirective.RemoveShortcutSpace}'"
             remove-shortcut-space
             class="button-link"
             on-remove="ctrl.handleConfirm(option)"
             report="option.directive.attrs.report"
             space="option.directive.attrs.space">
            {{ option.label }}
          </button>
          <button ng-if="option.directive && option.directive.name === '${SelectionOptionDirective.DeleteReport}' && !option.isDataset"
             mode-delete-report
             class="button-link"
             report="option.directive.attrs.report"
             on-report-deleted="option.directive.attrs.onReportDeleted($reportToken)">
            {{ option.label }}
          </button>
          <button ng-if="option.directive && option.directive.name === '${SelectionOptionDirective.DeleteReport}' && option.isDataset"
             class="button-link"
             ng-click="ctrl.deleteDataset(option.reportToken)">
            {{ option.label }}
          </button>
          <a ng-if="!option.isDivider && !option.directive && !option.confirm"
             ng-class="option.disabled ? 'disabled' : 'overflow-menu-link'"
             ng-click="ctrl.handleSelect(option)">
            <span>
              {{option.label}}
            </span>
          </a>
          <modal-dialog-link
            ng-if="!option.directive && option.confirm"
            confirm-button-cancel="{{ option.confirm.buttonCancel || 'Cancel' }}"
            confirm-button-confirm="{{ option.confirm.buttonConfirm || 'Ok' }}"
            confirm-content="option.confirm.content"
            confirm-title="option.confirm.title"
            modal-theme="{{ option.confirm.modalTheme }}"
            modal-type="{{ option.confirm.modalType }}"
            on-confirm="ctrl.handleConfirm(option)"
          >
            <span class="menu-item-label__title">{{option.label}}</span>
          </modal-dialog-link>
        </li>
      </ul>
    </div>
  `,
};
